import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Config from "config";
const Authmiddleware = (props) => {
  // const token = useSelector((state) => state.Login.token) Redux
  const backUrl = Config.backOffice.url;
  const token = localStorage.getItem("auth_token");
  if (!token) {
    return (
      <Navigate
        to={{ pathname: `${backUrl}/login`, state: { from: props.location } }}
      />
    );
  }
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;
